import { FiltersPayloadType } from '@/features/choice/types';
import { IChoiceFilters } from '@/interfaces/choice.interfaces';
import { IFilterGridItem } from '@/interfaces/constructor.interfaces';
import { FiltersItemType } from '@/interfaces/filters.interfaces';

import getFilterInitialValue from './getFilterInitialValue';

/**
 * Получить значения выбранных фильтров на основе
 * начальных значений фильтров указанных при инициализации
 * @param initialFilters {object} Начальные значения фильтров
 * @param flattenFilters {object} Данные по фильтрам из настроек приложения
 * @param filters {object} Данные по всем фильтрам
 */
const getFiltersInitialValues = (
  initialFilters: IChoiceFilters,
  flattenFilters: IFilterGridItem[],
  filters?: FiltersItemType,
) => {
  const result: FiltersPayloadType = {};
  Object.keys(initialFilters).forEach(key => {
    const filterGridItem = flattenFilters.find(item => item.key === key);
    const value = getFilterInitialValue(
      key,
      initialFilters[key],
      filterGridItem,
      filters,
    );
    if (typeof value !== 'undefined') {
      result[key] = value;
    }
  });

  return result;
};

export default getFiltersInitialValues;
